import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const Impressum = () => {
  return (
    <div className="bg-charcoal min-h-screen text-zinc-100">
      <div className="max-w-3xl mx-auto px-6 pt-24 pb-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-yellow hover:underline mb-10 font-medium"
        >
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>

        <h1 className="font-display text-yellow text-4xl md:text-5xl mb-10">Impressum</h1>

        <section className="space-y-6 leading-relaxed text-zinc-200 text-lg">
          <p className="font-heavy text-yellow text-2xl">LLIT-Media</p>

          <p className="font-semibold text-white">Till Sommer</p>

          <p>
            Armsener Straße 5<br />
            28325 Bremen<br />
            Deutschland
          </p>

          <p>
            Telefon:{' '}
            <a
              href="tel:+4915229816526"
              className="hover:text-yellow underline-offset-4 hover:underline"
            >
              015229816526
            </a>
          </p>

          <p>
            Mail:{' '}
            <a
              href="mailto:info.llit.media@gmail.com"
              className="hover:text-yellow underline-offset-4 hover:underline break-all"
            >
              info.llit.media@gmail.com
            </a>
          </p>

          <p>Kleinunternehmer gemäß § 19 UStG</p>

          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
            bereit, die Sie hier finden{' '}
            <a
              href="https://ec.europa.eu/consumers/odr/"
              target="_blank"
              rel="noreferrer"
              className="text-yellow underline-offset-4 hover:underline break-all"
            >
              https://ec.europa.eu/consumers/odr/
            </a>
            .
          </p>

          <p>
            <span className="font-heavy text-yellow">Wichtiger Hinweis:</span> Die Plattform zur
            Online-Streitbeilegung (OS) wird zum 20.7.2025 endgültig eingestellt. Die Einreichung
            von Beschwerden auf der OS-Plattform wird daher bereits am 20.3.2025 eingestellt.
            Zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            sind wir nicht verpflichtet und nicht bereit.
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Impressum;
